module.exports = __webpack_public_path__ + "static/img/pingguo.649c830f.png";